import $ from "jquery";
let Dispatcher;

let DownloadStore;
let EventEmitter;
let Metrics;
let StripeStore;
let UserStore;

EventEmitter = require("events").EventEmitter;

Dispatcher = require("../dispatcher/dispatcher").default;

Metrics = require("../helpers/metrics").default;

UserStore = require("../stores/userstore").default;

StripeStore = require("../stores/stripestore").default;

DownloadStore = (() => {
    class DownloadStore {
        constructor() {
            let purchasedIcon;
            this._emitter = new EventEmitter();
            this._phases = {
                INITIAL: "INITIAL",
                AUTHENTICATE: "AUTHENTICATE",
                SELECT_LICENSE: "SELECT_LICENSE",
                PAY: "PAY",
                POST_DOWNLOAD: "POST_DOWNLOAD",
                POST_DOWNLOAD_ATTRIBUTION: "POST_DOWNLOAD_ATTRIBUTION"
            };
            this._statuses = {
                WAITING: "WAITING",
                PROCESSING: "PROCESSING",
                SUCCESS: "SUCCESS",
                FAILURE: "FAILURE",
                COMPLETE: "COMPLETE"
            };
            this._currentPhase = this._phases.INITIAL;
            this._currentStatus = this._statuses.WAITING;
            this._data = {};
            this._purchasedIcons = [];
            this._error = "";
            purchasedIcon = $("meta[name=purchased_icon]").attr("content");
            if (!isNaN(parseInt(purchasedIcon))) {
                this._purchasedIcons.push(purchasedIcon);
            }
            this.initialize();
            this.dispatchToken = Dispatcher.register(
                (_this => payload => {
                    let ref;
                    switch (payload.actionType) {
                        case "requestDownload":
                            if (payload.icon !== void 0) {
                                if (
                                    _this._data.pendingDownload !== null &&
                                    _this._data.pendingDownload.id !==
                                        payload.icon.id
                                ) {
                                    _this.initialize();
                                }
                                _this._data.pendingDownload = payload.icon;
                            }
                            if (payload.downloadType !== void 0) {
                                _this._data.downloadType = payload.downloadType;
                            }
                            if (payload.imgType !== void 0) {
                                _this._data.fileUrl = null;
                                _this._data.imgType = payload.imgType;
                                _this._data.img_color = payload.img_color;
                            }
                            if (
                                _this._currentStatus ===
                                _this._statuses.COMPLETE
                            ) {
                                _this._currentPhase = _this._phases.INITIAL;
                                _this._currentStatus = _this._statuses.WAITING;
                            }
                            _this._data.PostDownload = payload.PostDownload;
                            return _this.nextPhase();
                        case "confirmDownload":
                            if (
                                (ref = _this._currentStatus) ===
                                    _this._statuses.SUCCESS ||
                                ref === _this._statuses.FAILURE
                            ) {
                                if (
                                    _this._data.downloadType === "attribution"
                                ) {
                                    _this._currentPhase =
                                        _this._phases.POST_DOWNLOAD_ATTRIBUTION;
                                }
                                _this._currentStatus = _this._statuses.COMPLETE;
                                _this._data.fileUrl = null;
                                return _this.emitEvent("change");
                            }
                            break;
                        case "abortDownload":
                            return _this.initialize();
                        case "userUpdated":
                            if (_this._data.pendingDownload) {
                                return _this.nextPhase();
                            }
                            break;
                        case "aLaCartePayment":
                            if (_this._data.pendingDownload) {
                                return _this.nextPhase();
                            }
                    }
                })(this)
            );
        }

        initialize() {
            this._currentPhase = this._phases.INITIAL;
            this._currentStatus = this._statuses.WAITING;
            this._data = {
                pendingDownload: null,
                imgType: null,
                downloadType: null,
                fileUrl: null,
                showDownloadModal: false
            };
            return this.emitEvent("change");
        }

        nextPhase() {
            switch (this._currentPhase) {
                case this._phases.INITIAL:
                    this._currentPhase = this._phases.AUTHENTICATE;
                    return this.nextPhase();
                case this._phases.AUTHENTICATE:
                    if (UserStore.isLoggedIn()) {
                        this._currentPhase = this._phases.SELECT_LICENSE;
                        return this.nextPhase();
                    }
                    break;
                case this._phases.SELECT_LICENSE:
                    this._data.showDownloadModal = true;
                    if (this._data.downloadType === "attribution") {
                        if (this._data.PostDownload === true) {
                            this._currentPhase = this._phases.POST_DOWNLOAD_ATTRIBUTION;
                            this.nextPhase();
                        } else {
                            return this.nextStatus();
                        }
                    } else if (
                        UserStore.hasPremiumMarketAccess() ||
                        this._data.pendingDownload.license_description ===
                            "public-domain" ||
                        this._purchasedIcons.indexOf(
                            this._data.pendingDownload.id
                        ) > -1
                    ) {
                        if (this._data.PostDownload !== true) {
                            this._data.PostDownload = false;
                            this._data.showDownloadModal = false;
                        } else {
                            this._currentPhase = this._phases.POST_DOWNLOAD;
                            this.nextPhase();
                        }
                        this._data.downloadType = "non-attribution";
                        return this.nextStatus();
                    } else if (this._data.downloadType === "non-attribution") {
                        this._currentPhase = this._phases.PAY;
                        return this.nextPhase();
                    }
                    break;
                case this._phases.PAY:
                    this._data.showDownloadModal = true;
                    if (StripeStore.get("charge")) {
                        this._currentPhase = this._phases.POST_DOWNLOAD;
                        return this.nextStatus();
                    }
                    if (UserStore.hasPremiumMarketAccess()) {
                        this._currentPhase = this._phases.POST_DOWNLOAD;
                        return this.nextStatus();
                    }
                    break;
                case this._phases.POST_DOWNLOAD:
                    this._data.showDownloadModal = true;
                    return this.nextStatus();
                case this._phases.POST_DOWNLOAD_ATTRIBUTION:
                    return this.nextStatus();
            }
            return this.emitEvent("change");
        }

        nextStatus() {
            switch (this._currentStatus) {
                case this._statuses.WAITING:
                    this._currentStatus = this._statuses.PROCESSING;
                    return this.nextStatus();
                case this._statuses.PROCESSING:
                    if (this._data.fileUrl) {
                        if (
                            this._currentPhase === this._phases.PAY ||
                            this._currentPhase === this._phases.POST_DOWNLOAD
                        ) {
                            this._purchasedIcons.push(
                                this._data.pendingDownload.id
                            );
                        }
                        this.doDownload();
                        this._currentStatus = this._statuses.SUCCESS;
                    } else {
                        this.sendDownloadRequest();
                    }
            }
            return this.emitEvent("change");
        }

        emitEvent(eventName, data) {
            if (data == null) {
                data = null;
            }
            if (data !== null) {
                return this._emitter.emit(eventName, data);
            } else {
                return this._emitter.emit(eventName);
            }
        }

        addListener(eventName, callback) {
            return this._emitter.on(eventName, callback);
        }

        removeListener(eventName, callback) {
            return this._emitter.removeListener(eventName, callback);
        }

        get(key) {
            return this._data[key];
        }

        getAll() {
            return this._data;
        }

        getCurrentPhase() {
            return this._currentPhase;
        }

        getCurrentStatus() {
            return this._currentStatus;
        }

        getDownloadData() {
            let postData = {
                icon_id: this._data.pendingDownload.id,
                img_type: this._data.imgType
            };
            if (UserStore.hasPremiumMarketAccess()) {
                if (postData["img_type"] === "svg") {
                    postData["img_color"] = this._data.img_color;
                } else {
                    postData["img_color"] = this._data.img_color;
                }
            }
            return postData;
        }

        doDownload() {
            $("body").append(
                "<iframe src='" +
                    this._data.fileUrl +
                    "' class='hidden' width='0' height='0'>"
            );
            return new Metrics().download(
                this._data.downloadType,
                this._data.imgType,
                this._data.pendingDownload
            );
        }

        sendDownloadRequest() {
            let postData = this.getDownloadData();
            if (
                postData["img_color"] !== undefined &&
                postData["img_type"] === "svg"
            ) {
                // premium color download
                this._data.fileUrl = `/icon/${
                    this._data.pendingDownload.id
                }/download/color/${postData["img_color"]}/${
                    postData["img_type"]
                }/`;
                return this.nextStatus();
            } else if (
                postData["img_color"] !== undefined &&
                postData["img_type"] === "png"
            ) {
                this._data.fileUrl = `/icon/${
                    this._data.pendingDownload.id
                }/download/color/${postData["img_color"]}/${
                    postData["img_type"]
                }/`;
                return this.nextStatus();
            } else {
                return $.post(
                    "/icon/" + this._data.pendingDownload.id + "/download/",
                    postData
                )
                    .done(
                        (_this => (data, status, xhr) => {
                            if (data.ok === true) {
                                // to handle s3 url downloads
                                _this._data.fileUrl = data.download;
                                return _this.nextStatus();
                            } else {
                                _this._error = data.error;
                                _this._currentStatus = _this._statuses.FAILURE;
                                return _this.emitEvent("change");
                            }
                        })(this)
                    )
                    .fail(
                        (_this => (xhr, status, err) => {
                            _this._error = err;
                            _this._currentStatus = _this._statuses.FAILURE;
                            return _this.emitEvent("change");
                        })(this)
                    );
            }
        }
    }

    return DownloadStore;
})();

export default new DownloadStore();
